export default __webpack_public_path__ + "static/media/home-github-white.809b8437.svg";